import { NotFound } from 'src/pages/NotFound/Index'
import { Home } from 'src/pages/Home'
import { UserProfile } from 'src/pages/UserProfile'
import { BuyTicket } from 'src/pages/BuyTicket'
import { Histories } from 'src/pages/Histories'
import { ListOrder } from 'src/pages/ListOrderAdmin'
import { CheckIn } from 'src/pages/CheckIn'
import { HDTT } from 'src/pages/Home/hdtt'
import { DKCS } from 'src/pages/Home/dkcs'
import { OrderResult } from 'src/pages/BuyTicket/OrderResult'

export const routes = [
  {
    path: '404',
    name: 'Not Found',
    component: NotFound,
    isPublic: true,
  },
  {
    path: '',
    name: 'Home',
    component: Home,
    isPublic: false,
    icon: 'home',
  },
  {
    path: 'huong-dan-thanh-toan-vnpay-tren-website',
    name: 'Hướng dẫn thanh toán',
    component: HDTT,
    isPublic: false,
    icon: 'home',
  },
  {
    path: 'chinh-sach-va-dieu-khoan',
    name: 'Điều khoản và chính sách',
    component: DKCS,
    isPublic: false,
    icon: 'home',
  },
  {
    path: 'ReturnUrl',
    name: 'Kết quả giao dịch',
    component: OrderResult,
    isPublic: false,
    icon: 'home',
  },
  {
    path: '/histories',
    name: 'Lịch sử đặt vé',
    component: Histories,
    isPublic: false,
    icon: 'home',
  },
  {
    path: 'buy-ticket',
    name: 'Buy Ticket',
    component: BuyTicket,
    isPublic: false,
    icon: 'home',
  },
  {
    path: 'list-order',
    name: 'Danh sach đơn hàng',
    component: ListOrder,
    isPublic: false,
    icon: 'home',
  },
  {
    path: 'check-in',
    name: 'check-in',
    component: CheckIn,
    isPublic: false,
    icon: 'home',
  },
  {
    path: 'user-profile',
    name: 'User profile',
    component: UserProfile,
    isPublic: false,
    icon: 'setting',
    className: 'absolute bottom-[-68%]'
  },
]
